
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexMUlF8yL1_45Y2I0AesSS_motPR3SUDvZRAjl3H_45W0oXYYMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/index.vue?macro=true";
import { default as logindXuUIs2rxWBf0bVfy4s00Wf_VPkvQmlGyk_4548Z36MGEMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/login.vue?macro=true";
import { default as mgeni1vylHDNW_45b14gioe1Yn2QqXsTN7uErQ5Ye9_rNlap0Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/quiz/mgen.vue?macro=true";
import { default as indexbrSVSC_45UwZr5f_45z8QDgsq4WabT_45U7h74HB7mBF3JI40Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/index.vue?macro=true";
import { default as notesd5wUf1Bp2G5W4vdjOArzHamhY1UvuQYWGvMifDtyFNAMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/notes.vue?macro=true";
import { default as indexAH77TYjRXyhsSUpsX7oZBObTe8v6PMWHDlO_J1_45lMScMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentKgwUOzvd7EPXFtl6_45DIfdNA9qESd9hPF4W7sdcgqcUcMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45siteapCWKGJoah31EC6j6OeFOvXbdu_45liSirRk0sUelNCosMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/plan-du-site.vue?macro=true";
import { default as editjhLcfTkGRvshanCkL0lnSCUt_45MDjkKZO6VFgK0Gd1GcMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/edit.vue?macro=true";
import { default as placesLMWaPYw6A_45gpg7Q8smvxpR9R1Pmqn1cdXvyGZRcbIfIMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/stats/places.vue?macro=true";
import { default as accessibilitescgOfPIO6uxNotcb_WG5_45ohpdFQ55xMCbSOJUXlZ2QkMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/accessibilite.vue?macro=true";
import { default as _91id_93ivitjsuxyKg1Ch1RnyEvqh_hK8E1Wz_45_45_45lcy2kyTXnkMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/messages/[id].vue?macro=true";
import { default as notificationsrSv_45NDaFleuRA1XrOmxuXybGgfrtwhuC0hSWulm_45TEoMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/notifications.vue?macro=true";
import { default as indexe6LTeWQztEiT9yMUVXakTjYaIbsuk0_45D8_45RNTO1PEUsMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/index.vue?macro=true";
import { default as indexril86FZc7gbtojV3WayKEf0UhWrTTQFmGcWPwJec5moMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/index.vue?macro=true";
import { default as _91slug_935BY4YohjeOpi7NJ1_45LHrUxHEMkuFRD_45tYsY9ujIVz4gMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/villes/[slug].vue?macro=true";
import { default as indexrGTAdz4bSKlng0mJSMW_2RipUmMEvwkzh0Z_45qo5_QtkMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/messages/index.vue?macro=true";
import { default as generiqueXyLcwLMqhX31fSbcUg68_45aRVuWCfLo1MaG2CdDVpWJAMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93O_dDnVa25DBk_GUzkYvFG3NHXnVN9VBcx375FcXozgoMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/reseaux/[slug].vue?macro=true";
import { default as missionsbpb2U8Q3L1KlRy_4507mrkpMdrDbfqMmKTgdqwCGd2MtcMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/stats/missions.vue?macro=true";
import { default as indexerYMV6tnCo9nNDQZDOyWCJad2s6euiywo8UDa579ZcoMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/dashboard/index.vue?macro=true";
import { default as favorisn8eS4rwlz2H0mTlySQENO5uSxlSck_45xtasp4WygVXyEMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/favoris.vue?macro=true";
import { default as _91slug_933y4g0NCB35uR4uppmtrTXcSnysm5PuuBMqONX60a3ecMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/activites/[slug].vue?macro=true";
import { default as logshL4lSbZ0YJ2tR2Nr_45bAR9IYzSq_45r1yWuWy0LmZnrnLkMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/other/logs.vue?macro=true";
import { default as ressourcesPl1aurCHcClwtuoO4x2M1_2NJutTEgWEDSbTlan4lC4Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legaleszBt1dWilx8ThwWxGVyyOYWyMXMOSgDt5DedQ24YjMFQMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/mentions-legales.vue?macro=true";
import { default as missionslyRRLdObo5d3bF1L0_45c1_0lPwmkwIqYw1rRhbhfYke8Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/missions.vue?macro=true";
import { default as settingsciDHcAkwqT3G8a8BEBO9HsvSs3hduqGwKgKUiR7_45W2EMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/settings.vue?macro=true";
import { default as temoignagesOQWWcYfjNHQszslvDDjKAdfu4twZFLttTy4c5MRF7uwMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/temoignages.vue?macro=true";
import { default as indexxFJYAhfSH4A7PMCCIikWLcNExONdySdD1p8TDNpfxIIMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/index.vue?macro=true";
import { default as adminlbdPGUaPrmR53nL2zzRIc6aJeAXm8k6n6cdXB0ift44Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/maintenance/admin.vue?macro=true";
import { default as index3Vidr4ze_45YwQN1lO4GD4OytJLS1r_45Yt1MXadC_45reDVgMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/maintenance/index.vue?macro=true";
import { default as indexeNA_459AwPSqtI7SYf16trRyb8miqNphNtCJN_rr726ZgMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/territoires/index.vue?macro=true";
import { default as _91hash_93lGt5f5355iRazF0Yrbr4u4aQBqvX6aA4FdEMIILreGsMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/invitations/[hash].vue?macro=true";
import { default as utilisateursbGeNRD1mi1NmeLpC4RMr30TV89zIvXbe7B8QbfUJ77YMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93hefzqwhx5BNCcXRkJ_kJ92xNrYGWkssRKVKbYq1D9aIMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/associations/[slug].vue?macro=true";
import { default as _91slug_93l9cD9KGe1eVEN83Iz45wa6yLH_455jR3XudlqciK_oKo4Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/departements/[slug].vue?macro=true";
import { default as indexnwhn_5wfa8avECvzx0foWgxugDPHsEbcWaxmryCkducMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/organisations/index.vue?macro=true";
import { default as preferences5y1sLGe9A_zE9j8iQmW69Ka09AbhiqWHSjnsiHCeUWAMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/preferences.vue?macro=true";
import { default as organisationsfH_45EueIjYmxO_gbFjfbd8JKgGY4ctxv8orwnDIz3BbUMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/stats/organisations.vue?macro=true";
import { default as _91token_93_mey0HPJ8VZEMaxiSbwmXzW_V1gqGUcZ2uMDvayEi9IMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/temoignages/[token].vue?macro=true";
import { default as postsNicRWNeDVpZMHQy4L7z3evXxyDGP4AmlEsfFMLMPztMMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/posts.vue?macro=true";
import { default as index05D5cUlBfzjPoiLcKvwb0_455MHXXiMGd_45HftVQV_BuMoMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/index.vue?macro=true";
import { default as addwrMwtDL2hdCXs3PKEc9e7Jxz2ERVUSrwsy_45tydmZocgMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_93WENSdXB7oWph25xh4agdt0ivrlovP_I3WZfglz48Z4YMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/organisations/[slug].vue?macro=true";
import { default as indexWmGbI5I1xRWtYelYxFeL_45Ob_45HPtML4IgI7Jak_wygxEMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/password-reset/index.vue?macro=true";
import { default as participations762F04X7vJTtxV2ZAAtC_dZLHnlG1LafDtJMt5IfWH0Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/stats/participations.vue?macro=true";
import { default as emailsIVdSpbhv516W4Y84geqcK_45IOgxUO_6CjR6uAWbqnW2EMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/settings/emails.vue?macro=true";
import { default as index0O62qSkKhJxMqMAYhs_454_45_45LjD2RULRmXZ1ufgVOcJvkMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/alertes/index.vue?macro=true";
import { default as notificationscF_45Vqkoziwng9jspz09YrVIzjkH91tPGhzXC35zZQwsMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/notifications.vue?macro=true";
import { default as indexWEUaM7WVn4cqoiUdaFGnulv1d_45LNG9efl9ZQLDwOEHwMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civiqueiH9LMkM0EDZmNx_45hn_45wT84cYNvLyYRXIgLeR0XmbBJ0Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_93JPJBKvAhTAqJ1Yb4Zia5muc4Kg9pJndwqDJ6oCyt_455AMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/domaines-action/[slug].vue?macro=true";
import { default as indexZi_AlQhwqFgPHQi5MCs6ZPAllZLLKco7LksU_45xIqMMQMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93w_4547vAXWU2fxYSDsIscBReVCDsePnTzuBXxWhXRGCIoMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensembleia4r0WNDlR_Da0PZV7h5r2Jf0WhPakKPHE7hNrQ6XKYMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitations1sS1xdBYGIq_025OyZz6_1ff2rx2QDxUAa0LZDVlyh4Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/other/invitations.vue?macro=true";
import { default as messageswFdz8aoosZVvYmOIy_45VTdzXxaEjY5bA2M6TUsaQAJ8sMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/settings/messages.vue?macro=true";
import { default as placesE2Q8tZIGTOXqya3P6OA5mlYndVyLPaMsaDJsB03kl_45QMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/places.vue?macro=true";
import { default as adddGTrIgaE62kclIrTZ1soaVrem10Bdy5I6ViJENJ6eCcMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/settings/rules/add.vue?macro=true";
import { default as indexHGcNSgGwcM87qGU_45yEqvLWFQBXrPw35oZxMo7o1uxfEMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/utilisateurs/index.vue?macro=true";
import { default as indexXS_7TIgsEJZtn69QI9E4YquLu0jf73URjFt1botWZwsMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/missions-benevolat/index.vue?macro=true";
import { default as datesji_6V61iAUAoexYBHlLLssWcn2UuM946dcU4Bmkf0akMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as indexv8vm_5IPx5GWRMWS90duqWG9G13g84DpdyMaCRisWPAMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieuxyXq7w4Z_45BkOjtkvnVMJ7COIy3BZZ2dvQbZZ2WrgJF0oMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as titleMJsqiI8GcST2tyCHAUEL8m2ONjPGB67pJ8Wv12AnxOsMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/title.vue?macro=true";
import { default as indexCo25EHrL66gaf7xrB4yAHMkZAq_45_45i9OGvvBHNQRfpv4Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/organisations/index.vue?macro=true";
import { default as missionsnnUa6seOnlXb1anFf1rl8M59qvooiTFbr7C_zxaOWUIMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/missions.vue?macro=true";
import { default as addm_45HcQ1L3aPgQlklPCk9KtidtMZWpeu1ulS5E_1kF5awMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visuelzzkoKIvTRhLdAPmffTDrvcUvT_45L5TNU_yaOUZLM0oAIMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as index_p_ZkZwx9EwavF_ZL4mOQKXkFV_455kwoWf7YjTpFLXCAMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/participations/index.vue?macro=true";
import { default as indexh_MOTf3gWLAMpf94MjFxlUpEWtmhGuCOsuetHoMw11cMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/settings/rules/index.vue?macro=true";
import { default as index_DxTpLiCw8Og0jiwyLW5eKnO8RijfaU6S3wqoEASuZcMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/benevole/index.vue?macro=true";
import { default as addb_qJAQHU85XTug29vzlWS8mq15JvStkYGFrCr8cC8p8Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as addHshMtUAlXStJUUSXl3soaHtYPRACpJ9s0k7sKPUeywQMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addA0g_459FCVdUudsshJxmhDuA1TqFeBox8nPcgJ4L0K5_45MMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexjephReI0nh5hjcZ3tjG_457VPTvijm4t_ZWikvpuF6ZoYMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversionsFM_45whJQ5fcSxOkiatQW8fgIi15RtjxoEJ2xU2qQ7rI8Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/conversions.vue?macro=true";
import { default as editoYVVSOiGJ1w7PglfwXkn_45RFSf9JIjSgSBTYMx4s9AusMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialiteaHCRRxFnjsPsAKRiYsGyzge6OYB7WII_45xRxWm9lbLTUMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/politique-de-confidentialite.vue?macro=true";
import { default as indexEu1dlavDuVoY9TNmNaMJMYZV_6qdYGX_45PYnyJtRyulUMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as addm4x9Wtf_45Pm0nmcuoZW2X9AnrQgBw4jY8yhqLRRFRb_45cMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevolesJ_45DHBijqJwRb2GS2kYcchNKdw8GGjXmJ0r_Yv8dUalMMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editrGzahDZ_453TElJf7fQ08YfTxU13azMzzI2VSNl7NEMkIMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateursKKbjlAd69dMZM37t2bXQgoqr_0i21ftnlluYRaM_FJkMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as index7LFt3LP2cX2PxzT8KwazGCc6LcGKiGav3x2H11v4fKUMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as indexT8YS4JNz_45PV3_XWKIfh6QXyvVIxda3fyECOqCZtrIGQMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexwl3WjOFH200M_45fbwsk7m68Er_45kp_w9aa7Q9It2DuPGsMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/index.vue?macro=true";
import { default as indexrFi2NVcwihFAUUoAXXfOzaDcJHtZfNcp_45gANFwu_45kY4Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendreV1Owy6cFhu34aMsIhOuaIJbALvzQR4lgScs5RVWzWPIMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as indexxvK_45GHmVgA6ljh8gtV_45FDtDLfC_4O5J2Elsk4Zb6ezwMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/activites/index.vue?macro=true";
import { default as add_yKe9Tjc3qxYKiHzqSF51_yrcIz04n5avCArGr2iA60Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as indexGIBOlw_ZGEn3Rhpf_V2WhEDFNAQb2Kit3JAos88a3aUMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as editZUbTW4Wu2o4RBkmLhEgbOxFCoF4CXqJbyWWXjnhIovkMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_93_45I02_456Lz_n78dK3jYS9fxC3_mDwTA2TMcNmbhdwdyV8Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planeteKj1O5ovIUKT1pRfl2_45NeyRX9kUvEPXNr8zi4UdyMl0UMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as index6Og0ZcBkGXyb1kEwYd_d4F93OhdZkKpNqoC3DGNk_45TwMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participationsN6MotufIwmqNyeRgyJt_REKOgFDeUSsvhAtBv6kRJFIMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/participations.vue?macro=true";
import { default as index8NeKEHj8QoBJw9ayI3qNRtqB3ewrX2yDVQYt2e2dVeIMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logsbZLe5w_qj7qkP5zcjloR_8b75G_OdGpwCNRuHhMWtbUMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/referents/activity-logs.vue?macro=true";
import { default as editsr8umLaEP0r_k01xeSzDajx2C_457NcTrX5R9UWTMibAkMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as indexgCjeuHqEVvk5ZiREeHA_AA8wPCICkxHr37coaEgKqgsMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsK8g6K37d1b42eGE_nUNgryGRo6VtGAaJZq3lmgerzpwMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsablesx0hTS1C5hrKbJdI13DzMzwhKaPo8d8lqhGAMK9bGAIoMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as edit8I6BhcrxdKDBOZ_QC_45gNB1ilMYpDDvKxDcvl0747BFwMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as index0eZ7aO48j4AJKy34uNv3PMY1oFlmQ4UWKPtWr6n8jaAMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as indexiuTQK2vSB4uo3M5qigpvPfCLB_453mXoQf67gr4gkg0CcMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45clesL82_vsGhArce9ipzHodMzsrKMcBkOYmP7rOKfDQeK5gMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as editj_453NMkPImYGK4X_cTaae27FQDumj2PjzNCYpzo5vYyYMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profilekjoQwmDtiNxIHzNHM1Tz9_45rWXzEWuGD0Bl3flNI5qboMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnementJUhNsOHhKXRnLA0UN_41x5Mt1Timp9241j9Ruxwe_45IoMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsfHAoW5XoP_Zn9NUhhXCkbzr68konqi7J_AGPD1JqffQMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/referents/waiting-actions.vue?macro=true";
import { default as editr8SnFCzGqQmONfNUnOQIZw3DEp0BmKB2PyVlxmshsasMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as add5NTY595IcbOZ3QgjkRHp58dSykq0Vgtn5HHG7l2nrwAMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationlsOMoPXNCidNde6cdiggRPrGh2jbMn5aG0uOKzkCTYgMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexvcwVtFpVzMwR3Qaio7YyOQeySoWa_45rCxF7MOWieekTEMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as editQe4gf2ijr55MUQL_45cxW1FTGIYTYonuAQXUhHHx57X7AMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusions8vjHsjxeuRphOqPW8f3DX1eLQqXrOJgAtU0a4Butfb0Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderations0OLPFuwBbPQrnWwxIAmRIQVPZ7LO26pml8AdPhIugAwMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevolesB3CA90t7InFetjy__b5jDEXfSBnaU3y1Ca4aMG3kVMYMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexingKMixs0xgodc8D8SciBCzinRFUKQ9cYtXVmr6vcS_rY4Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as indexfe0Jdlf6ei_4FV6CC0gAMF6dKcV5t_45fdhIV7FUEXfkoMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as edit9uOe2Gunad53VQwI6U7giiUTeh6darXahTEDugzDwTEMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indexKDMkCk7O1jhUIoZuphPdayPZe4K7q7Y9Njqn2xC03TsMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profilej12DiYbZtlKoyn6ebcB6Q_EPlb5xq51QnCx49pdwFqMMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as indexfHKfiPjMBn56ZBwJjh6E_45_45VOS7U1Bxr7ThaStYOg5UEMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as edit58G51jZPUTaWkaob7FDQH8_UXD72NsEsmKq2JPi9slMMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as addtJxZPyonyhTeVNgkkERFMwbcQNMCo9e1TqBTRZS524kMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competencesMWd_fjrdVs7R1a26_J99qvAT1zfJOkZnmkYMGZC04UcMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferencesWkJ5suvrMoAzdN2a7nP2m1zXQdgW2rUNnDrTskuP2vYMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45users7ZHfowVQRTCwzcOzFieXsOHf4yNEeYu3DmtrDxsjPeAMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoiresvuiLNMP8_jgm_45twr6Nzk7KShfx46zdefHakzCkN1yIYMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsables544S5SXY_45V3ohT7rtKQELTuosuQ12K7zTWKFfUkbZSIMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisationhkY1XxpA0yTqa_4500BcafJw42PiRhqZF_UP8L0znw2IIMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdatedkkqQUV_45iHWpAEMzE3rqWGyFju5MEBZfjqfw7pSa9U4EMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45itemsFv4zFtYNBK88lee4ZZrD0rP3GqLkiYHpT72ixJRXiREMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45roleCw6_45x6NPEeTAz2IYz1NHvpsodZqA9yCbW3LmNiUyBSIMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisationsWqPChQHq4zPoMV4ojsKHNgsvQqgCBOayXZ3Az2FE3mQMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as editFhvLlNK4fvdMPvWFVoYw8U8yzM_sHefj088PDVDbJ88Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibilitesubo75J6QjNOuLzELNFo31wt4eEGhBNHc0CBq1zc_Lo4Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45linkPAquqmgkj__45yyzRuiLcjdJmBTKal_45qQnQMjVLgQbyjUMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as indexAY5mtx4EGtxpiLrmoICdY3_gKofe0M_pJX_45LJIpulJUMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectivitealCngHct2tfmC7NECn2Mb27ilPDX0MKEYDx7eBhvJOMMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisationVXXjEn5jyxp_d_45lvJOUNRjwQra9IQBIuTMRiz7h8lp0Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informationsPXi3C6jYn_45xk3CMzUMN1lwqHUl0HQ5dfDLnuFlqWaA0Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrantJxPBFXvSCq_45hDbApv6XxaXbmv2b36tsYirgMGmpLv5wMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortantvXShvX2dY3syUgahCesBIQlwgwaugMWuf3xpBmtNe1YMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as indexvlU8O5jVmBL7OQkPilRR47_45_45Qs_45CFgmH7DwBPjeT0XwMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimeesyf3DAhOBhXbO13dlm2DgcwtzWUJ1XBSoAe1kMQqKogQMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45validerU_45lKwIMZY1GBDMscjL38mWrIbMtzhIHBuZryn7YaIZEMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesy2ptqUCObDd1ksCq2gmA2B8zFol6DNjaYbHpwsmdCgMMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imagesFsUgMi0ovaNWaWanXnrf0Nr37MY8et_456PCQ_sz5hv1YMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45details_SvoJguigVNsFt2AyT1FxKTPIPNmoixByH8YRtrm6a0Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treatedZ1v68Szf6cO_45wVyEWfbvtLo37kpK6uhHHQT3_gie19AMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectAmbxAOqWuX80HGyp3yuNA8U7JST40Ku5onkcQnNfINgMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45valideryEwtjnBcpWBraJf9LHOkji7W1tQwuyvFSwVzCI5_45bBIMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnementPZH34QxWxa_H9GKy7yctwV9OaNvHV0SyBRQ9HEbIVYEMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmation5bCg6v0WkzQVohdebIoaZ2_45l94YZNSsbh5zW9uyFqQ4Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationyMSTtBHh6iBNAa_45oMmCfT_W4LQzhJWrVmG3FgEFffJMMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45validerNbwbw4nKPFTWWSzVeierU_3r02sugTA0skUOj2TwO5MMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annuleesTb5l1qzVpMrKiTNd7iHphteZP1rH4GNxT4hdSb46PDoMeta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4Meta } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4 } from "/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: logindXuUIs2rxWBf0bVfy4s00Wf_VPkvQmlGyk_4548Z36MGEMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/login.vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgeni1vylHDNW_45b14gioe1Yn2QqXsTN7uErQ5Ye9_rNlap0Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexbrSVSC_45UwZr5f_45z8QDgsq4WabT_45U7h74HB7mBF3JI40Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notesd5wUf1Bp2G5W4vdjOArzHamhY1UvuQYWGvMifDtyFNAMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: indexAH77TYjRXyhsSUpsX7oZBObTe8v6PMWHDlO_J1_45lMScMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: editjhLcfTkGRvshanCkL0lnSCUt_45MDjkKZO6VFgK0Gd1GcMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: placesLMWaPYw6A_45gpg7Q8smvxpR9R1Pmqn1cdXvyGZRcbIfIMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93ivitjsuxyKg1Ch1RnyEvqh_hK8E1Wz_45_45_45lcy2kyTXnkMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsrSv_45NDaFleuRA1XrOmxuXybGgfrtwhuC0hSWulm_45TEoMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexe6LTeWQztEiT9yMUVXakTjYaIbsuk0_45D8_45RNTO1PEUsMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexril86FZc7gbtojV3WayKEf0UhWrTTQFmGcWPwJec5moMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: indexrGTAdz4bSKlng0mJSMW_2RipUmMEvwkzh0Z_45qo5_QtkMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generiqueXyLcwLMqhX31fSbcUg68_45aRVuWCfLo1MaG2CdDVpWJAMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93O_dDnVa25DBk_GUzkYvFG3NHXnVN9VBcx375FcXozgoMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionsbpb2U8Q3L1KlRy_4507mrkpMdrDbfqMmKTgdqwCGd2MtcMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexerYMV6tnCo9nNDQZDOyWCJad2s6euiywo8UDa579ZcoMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisn8eS4rwlz2H0mTlySQENO5uSxlSck_45xtasp4WygVXyEMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logshL4lSbZ0YJ2tR2Nr_45bAR9IYzSq_45r1yWuWy0LmZnrnLkMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missionslyRRLdObo5d3bF1L0_45c1_0lPwmkwIqYw1rRhbhfYke8Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingsciDHcAkwqT3G8a8BEBO9HsvSs3hduqGwKgKUiR7_45W2EMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/settings.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: indexxFJYAhfSH4A7PMCCIikWLcNExONdySdD1p8TDNpfxIIMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: adminlbdPGUaPrmR53nL2zzRIc6aJeAXm8k6n6cdXB0ift44Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: index3Vidr4ze_45YwQN1lO4GD4OytJLS1r_45Yt1MXadC_45reDVgMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93lGt5f5355iRazF0Yrbr4u4aQBqvX6aA4FdEMIILreGsMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateursbGeNRD1mi1NmeLpC4RMr30TV89zIvXbe7B8QbfUJ77YMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferences5y1sLGe9A_zE9j8iQmW69Ka09AbhiqWHSjnsiHCeUWAMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisationsfH_45EueIjYmxO_gbFjfbd8JKgGY4ctxv8orwnDIz3BbUMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93_mey0HPJ8VZEMaxiSbwmXzW_V1gqGUcZ2uMDvayEi9IMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postsNicRWNeDVpZMHQy4L7z3evXxyDGP4AmlEsfFMLMPztMMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: index05D5cUlBfzjPoiLcKvwb0_455MHXXiMGd_45HftVQV_BuMoMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: addwrMwtDL2hdCXs3PKEc9e7Jxz2ERVUSrwsy_45tydmZocgMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_93WENSdXB7oWph25xh4agdt0ivrlovP_I3WZfglz48Z4YMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexWmGbI5I1xRWtYelYxFeL_45Ob_45HPtML4IgI7Jak_wygxEMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participations762F04X7vJTtxV2ZAAtC_dZLHnlG1LafDtJMt5IfWH0Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailsIVdSpbhv516W4Y84geqcK_45IOgxUO_6CjR6uAWbqnW2EMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: index0O62qSkKhJxMqMAYhs_454_45_45LjD2RULRmXZ1ufgVOcJvkMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notificationscF_45Vqkoziwng9jspz09YrVIzjkH91tPGhzXC35zZQwsMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: indexWEUaM7WVn4cqoiUdaFGnulv1d_45LNG9efl9ZQLDwOEHwMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexZi_AlQhwqFgPHQi5MCs6ZPAllZLLKco7LksU_45xIqMMQMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93w_4547vAXWU2fxYSDsIscBReVCDsePnTzuBXxWhXRGCIoMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensembleia4r0WNDlR_Da0PZV7h5r2Jf0WhPakKPHE7hNrQ6XKYMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitations1sS1xdBYGIq_025OyZz6_1ff2rx2QDxUAa0LZDVlyh4Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messageswFdz8aoosZVvYmOIy_45VTdzXxaEjY5bA2M6TUsaQAJ8sMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placesE2Q8tZIGTOXqya3P6OA5mlYndVyLPaMsaDJsB03kl_45QMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: adddGTrIgaE62kclIrTZ1soaVrem10Bdy5I6ViJENJ6eCcMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: indexHGcNSgGwcM87qGU_45yEqvLWFQBXrPw35oZxMo7o1uxfEMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: indexXS_7TIgsEJZtn69QI9E4YquLu0jf73URjFt1botWZwsMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: datesji_6V61iAUAoexYBHlLLssWcn2UuM946dcU4Bmkf0akMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: indexv8vm_5IPx5GWRMWS90duqWG9G13g84DpdyMaCRisWPAMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxyXq7w4Z_45BkOjtkvnVMJ7COIy3BZZ2dvQbZZ2WrgJF0oMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: titleMJsqiI8GcST2tyCHAUEL8m2ONjPGB67pJ8Wv12AnxOsMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: indexCo25EHrL66gaf7xrB4yAHMkZAq_45_45i9OGvvBHNQRfpv4Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionsnnUa6seOnlXb1anFf1rl8M59qvooiTFbr7C_zxaOWUIMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: addm_45HcQ1L3aPgQlklPCk9KtidtMZWpeu1ulS5E_1kF5awMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visuelzzkoKIvTRhLdAPmffTDrvcUvT_45L5TNU_yaOUZLM0oAIMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: index_p_ZkZwx9EwavF_ZL4mOQKXkFV_455kwoWf7YjTpFLXCAMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: indexh_MOTf3gWLAMpf94MjFxlUpEWtmhGuCOsuetHoMw11cMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: index_DxTpLiCw8Og0jiwyLW5eKnO8RijfaU6S3wqoEASuZcMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addb_qJAQHU85XTug29vzlWS8mq15JvStkYGFrCr8cC8p8Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: addHshMtUAlXStJUUSXl3soaHtYPRACpJ9s0k7sKPUeywQMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addA0g_459FCVdUudsshJxmhDuA1TqFeBox8nPcgJ4L0K5_45MMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexjephReI0nh5hjcZ3tjG_457VPTvijm4t_ZWikvpuF6ZoYMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversionsFM_45whJQ5fcSxOkiatQW8fgIi15RtjxoEJ2xU2qQ7rI8Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: editoYVVSOiGJ1w7PglfwXkn_45RFSf9JIjSgSBTYMx4s9AusMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: indexEu1dlavDuVoY9TNmNaMJMYZV_6qdYGX_45PYnyJtRyulUMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: addm4x9Wtf_45Pm0nmcuoZW2X9AnrQgBw4jY8yhqLRRFRb_45cMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevolesJ_45DHBijqJwRb2GS2kYcchNKdw8GGjXmJ0r_Yv8dUalMMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editrGzahDZ_453TElJf7fQ08YfTxU13azMzzI2VSNl7NEMkIMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateursKKbjlAd69dMZM37t2bXQgoqr_0i21ftnlluYRaM_FJkMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: index7LFt3LP2cX2PxzT8KwazGCc6LcGKiGav3x2H11v4fKUMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: indexT8YS4JNz_45PV3_XWKIfh6QXyvVIxda3fyECOqCZtrIGQMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendreV1Owy6cFhu34aMsIhOuaIJbALvzQR4lgScs5RVWzWPIMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexxvK_45GHmVgA6ljh8gtV_45FDtDLfC_4O5J2Elsk4Zb6ezwMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: add_yKe9Tjc3qxYKiHzqSF51_yrcIz04n5avCArGr2iA60Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: indexGIBOlw_ZGEn3Rhpf_V2WhEDFNAQb2Kit3JAos88a3aUMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: editZUbTW4Wu2o4RBkmLhEgbOxFCoF4CXqJbyWWXjnhIovkMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planeteKj1O5ovIUKT1pRfl2_45NeyRX9kUvEPXNr8zi4UdyMl0UMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: index6Og0ZcBkGXyb1kEwYd_d4F93OhdZkKpNqoC3DGNk_45TwMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participationsN6MotufIwmqNyeRgyJt_REKOgFDeUSsvhAtBv6kRJFIMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logsbZLe5w_qj7qkP5zcjloR_8b75G_OdGpwCNRuHhMWtbUMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: editsr8umLaEP0r_k01xeSzDajx2C_457NcTrX5R9UWTMibAkMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexgCjeuHqEVvk5ZiREeHA_AA8wPCICkxHr37coaEgKqgsMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsK8g6K37d1b42eGE_nUNgryGRo6VtGAaJZq3lmgerzpwMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsablesx0hTS1C5hrKbJdI13DzMzwhKaPo8d8lqhGAMK9bGAIoMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: edit8I6BhcrxdKDBOZ_QC_45gNB1ilMYpDDvKxDcvl0747BFwMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: index0eZ7aO48j4AJKy34uNv3PMY1oFlmQ4UWKPtWr6n8jaAMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indexiuTQK2vSB4uo3M5qigpvPfCLB_453mXoQf67gr4gkg0CcMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45clesL82_vsGhArce9ipzHodMzsrKMcBkOYmP7rOKfDQeK5gMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: editj_453NMkPImYGK4X_cTaae27FQDumj2PjzNCYpzo5vYyYMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profilekjoQwmDtiNxIHzNHM1Tz9_45rWXzEWuGD0Bl3flNI5qboMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsfHAoW5XoP_Zn9NUhhXCkbzr68konqi7J_AGPD1JqffQMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: editr8SnFCzGqQmONfNUnOQIZw3DEp0BmKB2PyVlxmshsasMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: add5NTY595IcbOZ3QgjkRHp58dSykq0Vgtn5HHG7l2nrwAMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexvcwVtFpVzMwR3Qaio7YyOQeySoWa_45rCxF7MOWieekTEMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: editQe4gf2ijr55MUQL_45cxW1FTGIYTYonuAQXUhHHx57X7AMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusions8vjHsjxeuRphOqPW8f3DX1eLQqXrOJgAtU0a4Butfb0Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderations0OLPFuwBbPQrnWwxIAmRIQVPZ7LO26pml8AdPhIugAwMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexingKMixs0xgodc8D8SciBCzinRFUKQ9cYtXVmr6vcS_rY4Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: indexfe0Jdlf6ei_4FV6CC0gAMF6dKcV5t_45fdhIV7FUEXfkoMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: edit9uOe2Gunad53VQwI6U7giiUTeh6darXahTEDugzDwTEMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indexKDMkCk7O1jhUIoZuphPdayPZe4K7q7Y9Njqn2xC03TsMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profilej12DiYbZtlKoyn6ebcB6Q_EPlb5xq51QnCx49pdwFqMMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexfHKfiPjMBn56ZBwJjh6E_45_45VOS7U1Bxr7ThaStYOg5UEMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: edit58G51jZPUTaWkaob7FDQH8_UXD72NsEsmKq2JPi9slMMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addtJxZPyonyhTeVNgkkERFMwbcQNMCo9e1TqBTRZS524kMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competencesMWd_fjrdVs7R1a26_J99qvAT1zfJOkZnmkYMGZC04UcMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferencesWkJ5suvrMoAzdN2a7nP2m1zXQdgW2rUNnDrTskuP2vYMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45users7ZHfowVQRTCwzcOzFieXsOHf4yNEeYu3DmtrDxsjPeAMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoiresvuiLNMP8_jgm_45twr6Nzk7KShfx46zdefHakzCkN1yIYMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisationhkY1XxpA0yTqa_4500BcafJw42PiRhqZF_UP8L0znw2IIMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedkkqQUV_45iHWpAEMzE3rqWGyFju5MEBZfjqfw7pSa9U4EMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45itemsFv4zFtYNBK88lee4ZZrD0rP3GqLkiYHpT72ixJRXiREMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45roleCw6_45x6NPEeTAz2IYz1NHvpsodZqA9yCbW3LmNiUyBSIMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationsWqPChQHq4zPoMV4ojsKHNgsvQqgCBOayXZ3Az2FE3mQMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: editFhvLlNK4fvdMPvWFVoYw8U8yzM_sHefj088PDVDbJ88Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibilitesubo75J6QjNOuLzELNFo31wt4eEGhBNHc0CBq1zc_Lo4Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45linkPAquqmgkj__45yyzRuiLcjdJmBTKal_45qQnQMjVLgQbyjUMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: indexAY5mtx4EGtxpiLrmoICdY3_gKofe0M_pJX_45LJIpulJUMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectivitealCngHct2tfmC7NECn2Mb27ilPDX0MKEYDx7eBhvJOMMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisationVXXjEn5jyxp_d_45lvJOUNRjwQra9IQBIuTMRiz7h8lp0Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationsPXi3C6jYn_45xk3CMzUMN1lwqHUl0HQ5dfDLnuFlqWaA0Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrantJxPBFXvSCq_45hDbApv6XxaXbmv2b36tsYirgMGmpLv5wMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortantvXShvX2dY3syUgahCesBIQlwgwaugMWuf3xpBmtNe1YMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: indexvlU8O5jVmBL7OQkPilRR47_45_45Qs_45CFgmH7DwBPjeT0XwMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimeesyf3DAhOBhXbO13dlm2DgcwtzWUJ1XBSoAe1kMQqKogQMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45validerU_45lKwIMZY1GBDMscjL38mWrIbMtzhIHBuZryn7YaIZEMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesy2ptqUCObDd1ksCq2gmA2B8zFol6DNjaYbHpwsmdCgMMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imagesFsUgMi0ovaNWaWanXnrf0Nr37MY8et_456PCQ_sz5hv1YMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45details_SvoJguigVNsFt2AyT1FxKTPIPNmoixByH8YRtrm6a0Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treatedZ1v68Szf6cO_45wVyEWfbvtLo37kpK6uhHHQT3_gie19AMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45valideryEwtjnBcpWBraJf9LHOkji7W1tQwuyvFSwVzCI5_45bBIMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmation5bCg6v0WkzQVohdebIoaZ2_45l94YZNSsbh5zW9uyFqQ4Meta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationyMSTtBHh6iBNAa_45oMmCfT_W4LQzhJWrVmG3FgEFffJMMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45validerNbwbw4nKPFTWWSzVeierU_3r02sugTA0skUOj2TwO5MMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annuleesTb5l1qzVpMrKiTNd7iHphteZP1rH4GNxT4hdSb46PDoMeta || {},
    component: () => import("/build/3f95df87-3085-40d4-bcec-a8c80711bbe8/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4Meta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4
  },
  {
    name: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4Meta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4
  },
  {
    name: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4Meta?.name,
    path: "/user/settings",
    component: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4
  },
  {
    name: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4Meta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4
  },
  {
    name: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4Meta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4
  },
  {
    name: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4Meta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4
  },
  {
    name: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4Meta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4
  },
  {
    name: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4Meta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4
  },
  {
    name: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4Meta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4
  },
  {
    name: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4Meta?.name,
    path: "/inscription/organisation",
    component: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4
  },
  {
    name: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4Meta?.name,
    path: "/statistiques",
    component: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4
  },
  {
    name: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4Meta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4
  },
  {
    name: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubHjdbPlzEv1DnyLAtZEEWiOoG27aw2zQIKbXPO0mJFK4
  }
]